import { GeneticEvaluationDto } from 'src/dto/genetic-evaluation.dto'
import { API } from '../config'
import { AxiosResponse } from 'axios'

const BASE_URL = '/entity/AnimalDep'
const UPLOAD_URL = '/uploadCsv'

export class GeneticEvaluationService {
  public async getGeneticEvaluationListByFarmId(farmId: string): Promise<AxiosResponse<GeneticEvaluationDto[]>> {
    return await API.get(`${BASE_URL}/${farmId}/null`)
  }

  public async uploadCsvFile(farmId: string, file: FormData): Promise<AxiosResponse<any>> {
    return await API.post(`${UPLOAD_URL}/${farmId}/true`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
